var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHotel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 256,
      height: 256,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4B4B4B;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M436.212,149.261V73.629c-0.008-19.945-16.156-36.103-36.108-36.111H111.899 C91.948,37.526,75.8,53.685,75.792,73.629v75.632L0,339.112v113.435c0.019,12.124,9.803,21.912,21.938,21.935h468.123 c12.135-0.023,21.92-9.811,21.939-21.935V339.112L436.212,149.261z M99.866,73.629c0.011-6.638,5.395-12.029,12.033-12.037h288.205 c6.638,0.008,12.022,5.399,12.034,12.037v76.502H381.97v-28.072c-0.004-19.388-15.712-35.1-35.108-35.108h-46.307 c-19.396,0.008-35.097,15.72-35.104,35.108v28.072h-18.902v-28.072c-0.008-19.388-15.708-35.1-35.104-35.108h-46.307 c-19.396,0.008-35.104,15.72-35.108,35.108v28.072H99.866V73.629z M365.921,122.059v28.072h-84.42v-28.072 c0.019-10.516,8.537-19.043,19.054-19.059h46.307C357.386,103.017,365.901,111.543,365.921,122.059z M230.5,122.059v28.072h-84.42 v-28.072c0.019-10.516,8.534-19.043,19.059-19.059h46.307C221.961,103.017,230.48,111.543,230.5,122.059z M94.957,166.18h322.09 l8.714,21.833H86.242L94.957,166.18z M79.836,204.063h352.333L483.8,333.406H28.2L79.836,204.063z M487.926,450.408H24.074V349.456 h463.851V450.408z",
    style: {
      fill: "rgb(40, 40, 70)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHotel);
export default __webpack_public_path__ + "static/media/icon_hotel.4ef54b387786ad34742f1dc613d310c7.svg";
export { ForwardRef as ReactComponent };